import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import {
    Button,
    Text,
    Spacer,
} from '@zillow/constellation';
import { Center } from '@zillow/zrs-comet';

import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import ListingActivationTerms from 'app/shared/components/ListingActivationTerms';

const propTypes = {
    handleConfirmClick: PropTypes.func,
};

const defaultProps = {
    handleConfirmClick: () => {},
};

// eslint-disable-next-line max-len
const bodyText = 'By enabling applications, renters on Zillow, Trulia and HotPads will be able to apply directly from your active rental listings.';
const buttonTitle = 'Enable applications';

const EnableApplicationsModal = ({ handleConfirmClick }) => {
    const dispatch = useDispatch();
    const onConfirmClick = () => {
        dispatch(analyticsUtils.track.GAEventV2(AnalyticsConstants.GA_EVENTS.APPLICATIONS_MODAL_ENABLE));
        handleConfirmClick();
    };

    return (
        <Center>
            <Text as="div" fontType="h6">Simplify your rental process.</Text>
            <Spacer marginBottom="lg" marginTop="sm">
                <Spacer marginBottom="xs">
                    <Text as="div">{bodyText}</Text>
                </Spacer>
                <Text as="div">You can also invite specific renters to apply for any of your properties.</Text>
            </Spacer>
            <Button buttonType="primary" fluid={true} onClick={onConfirmClick}>
                {buttonTitle}
            </Button>
            <ListingActivationTerms actionText={`By clicking ${buttonTitle}`} />
        </Center>
    );
};

EnableApplicationsModal.propTypes = propTypes;
EnableApplicationsModal.defaultProps = defaultProps;

export default EnableApplicationsModal;
